import { ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useMerchCart } from "@/contexts/MerchCartContext";

export function MerchCartFloatingButton() {
  const { t } = useTranslation();
  const { count, setOpen } = useMerchCart();

  return (
    <button
      onClick={() => setOpen(true)}
      aria-label={t("merch.cart.open")}
      className="fixed bottom-20 right-4 z-40 flex items-center gap-2 rounded-full bg-primary px-4 py-3 text-primary-foreground shadow-lg shadow-primary/30 transition-transform hover:scale-105 motion-reduce:transition-none sm:bottom-6 sm:right-6"
    >
      <ShoppingCart className="h-5 w-5" />
      <span className="flex h-6 min-w-6 items-center justify-center rounded-full bg-primary-foreground/20 px-1.5 text-sm font-bold">
        {count}
      </span>
    </button>
  );
}
